var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root job-type-badge",class:[_vm.jobType.badgeClass]},[_vm._v(_vm._s(_vm.jobType.title))])}
var staticRenderFns = []

export { render, staticRenderFns }